import React, { useEffect, useState } from "react";
import "./CustomerReport.css";
import { APIURL } from "../config";
import { Alert, Button } from "react-bootstrap";
import { FaAngleDoubleLeft } from "react-icons/fa";
import BreedBreakDown from "./BreedBreakDown";
import Dietcondition from "./dietcondition";
import HealthInsights from "./HealthInsights";
import Dog1data from "./dog1data";
import NutritionalInsights from "./NutritionalInsights";
import ImagePicker from "./ImagePicker";
import Loading from "./loading";
import { fetchHealthInfo, getPetSurveyByKitEmail } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { profileData } from "../jsonObject/staticData"

function CustomerReport({ kitData, goBack }) {
    const dispatch = useDispatch();
    const [years, setYears] = useState(null);
    const [surveyData, setSurveyData] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [filteredData, setFilterd] = useState("");
    const [reportData, setReportData] = useState("");
    const [loading, setLoading] = useState(false);
    const [conditions, setConditions] = useState([]);
    const [trueCount, setTrueCount] = useState(0);
    const [falseCount, setFalseCount] = useState(0);
    const [healthInsight, setHealthInsight] = useState(0);
    const healthInfo = useSelector((state) => state.health.healthInfo);
    const [imageBase64, setImageBase64] = useState(kitData?.imgBase64);
    const navigate = useNavigate();

    const location = useLocation();
    console.log("kitData", kitData);

    useEffect(() => {
        dispatch(fetchHealthInfo(kitData?.Kit_id));
    }, [dispatch, kitData?.Kit_id]);

    useEffect(() => {
        if (kitData?.imgBase64) {
            setImageBase64(kitData.imgBase64);
        }
    }, [kitData?.imgBase64]);

    useEffect(() => {
        if (healthInfo?.ItemInfo) {
            let affectedCount = 0;
            let carrierCount = 0;
            healthInfo?.ItemInfo.forEach((item) => {
                if (item?.status === "affected") {
                    affectedCount++;
                }
                if (item?.status === "Carrier") {
                    carrierCount++;
                }
            });
            setHealthInsight(affectedCount + carrierCount);
        }
    }, [healthInfo]);

    useEffect(() => {
        if (!kitData) return;

        let rawBirthday = kitData?.Birthday;
        let birthdayDate;

        if (typeof rawBirthday === "number") {
            birthdayDate = new Date(
                rawBirthday > 1e12 ? rawBirthday / 1000 : rawBirthday
            );
        } else {
            birthdayDate = new Date(rawBirthday);
        }

        const today = new Date();
        let age = today.getFullYear() - birthdayDate.getFullYear();
        const monthDiff = today.getMonth() - birthdayDate.getMonth();
        const dayDiff = today.getDate() - birthdayDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        setYears(age);
        setSurveyData(kitData);
        setLoading(true);
        const kitId = kitData?.kit_id || kitData?.Kit_id;
        if (!kitId) {
            console.warn("Kit ID is missing. Skipping API call.");
            setLoading(false);
            return;
        }

        const apiUrl = `${APIURL}/getBlastOffRuleResultByKitID?kit_id=${kitId}`;
        fetch(apiUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        "Network response was not ok. Status: " + response.status
                    );
                }
                return response.json();
            })
            .then((data) => {
                setErrorMessage(null);
                if (data.message === "success") {
                    const groupedResult = data?.ItemInfo.reduce((acc, item) => {
                        if (!acc[item.section_id]) {
                            acc[item.section_id] = {};
                        }
                        if (!acc[item.section_id][item.sub_section_id]) {
                            acc[item.section_id][item.sub_section_id] = [];
                        }
                        acc[item.section_id][item.sub_section_id].push(item);
                        return acc;
                    }, {});
                    setFilterd(groupedResult);
                }
            })
            .catch((error) => {
                setErrorMessage(error.message);
                setFilterd(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [kitData]);

    useEffect(() => {
        if (!filteredData || typeof filteredData !== "object") return;

        const ruleResult = filteredData;

        const conditions = Object.keys(ruleResult)

            .filter(
                (key) =>
                    key !== "foodrecommendations" && key !== "supplementrecommendations"
            )
            .map((item) => ruleResult[item]);

        let trueCount1 = 0;
        let falseCount1 = 0;

        conditions.forEach((condition) => {
            const variableValue =
                condition.Results && condition.Results.length > 0
                    ? condition.Results[0].variable1_value
                    : undefined;

            const value = variableValue
                ? variableValue.toLowerCase() === "high"
                : false;
            if (value) {
                trueCount1++;
            } else {
                falseCount1++;
            }
        });

        setTrueCount(trueCount1);
        setFalseCount(falseCount1);
    }, [filteredData]);

    const handleReportData = (filterValue) => {
        setReportData(filterValue);
    };

    return (
        <>
            {loading && <Loading />}
            <div className="reportContent">
                {/* <div className="profileSectionBack">
                    <Button className="buttonBack" onClick={() => goBack()}>
                        <FaAngleDoubleLeft size={30} />
                    </Button>
                </div> */}
                <div className="card-bg-color">
                    <section className="profile-section">
                        <h3 className="cutomreport-title">
                            {surveyData?.PetName}'s Profile
                        </h3>
                        <div className="dog-profile-container">
                            <div className="dog-details">
                                <div className="dog-profile">
                                    <ImagePicker
                                        key={kitData?.kit_id || kitData?.Kit_id}
                                        imgBlob={imageBase64}
                                        kitId={kitData?.kit_id || kitData?.Kit_id}
                                        onImageUpdate={setImageBase64}
                                    />
                                </div>
                                <div className="dog-profile-info">
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">Breed:</label>
                                        <span>
                                            {Array.isArray(surveyData?.BreedType) &&
                                                surveyData.BreedType.length > 0
                                                ? surveyData.BreedType.join(", ")
                                                : surveyData?.BreedType || "Chihuahua mix"}
                                        </span>
                                    </div>
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">Sex:</label>
                                        <span>{surveyData?.Gender}</span>
                                    </div>
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">Age:</label>
                                        <span>{years} years</span>
                                    </div>
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">Weight:</label>
                                        <span>{surveyData?.PetWeightInPounds} lbs</span>
                                    </div>
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">
                                            Medication/Supplements:
                                        </label>

                                        <span>
                                            {Array.isArray(surveyData?.ConsumingSupplements) &&
                                                surveyData.ConsumingSupplements.length > 0
                                                ? surveyData.ConsumingSupplements.join(", ")
                                                : surveyData?.ConsumingSupplements || "None"}
                                        </span>
                                    </div>
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">Veterinary Diet:</label>
                                        <span>No</span>
                                    </div>
                                    <hr style={{ width: "90%" }} />
                                    {/* <div className="mb-2">
                                        <label className="fw-bold me-2">Sample Date:</label>
                                        <span> November 22, 2022</span>
                                    </div> */}
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">Kit ID:</label>
                                        <span>{surveyData?.Kit_id}</span>
                                    </div>
                                    <div className="mb-2">
                                        <label className="fw-bold me-2">Pet Parent:</label>
                                        <span>{surveyData?.Name}</span>
                                    </div>
                                </div>
                                <div className="dog-profile-info">

                                    <div className="mb-2">
                                        {profileData.profileSection.map((para, i) => (
                                            <p key={i}>{para}</p>
                                        ))}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                    {errorMessage ? null : (
                        <section className="report-container">
                            <div className="card report-card mb-4">
                                <div
                                    className="card-body d-flex flex-column justify-content-between"
                                    style={{ height: "100%" }}
                                >
                                    <div>
                                        <h5 className="card-title">Nutrition Insights</h5>
                                        <p className="card-text">
                                            {" "}
                                            Unlock {kitData?.PetName}’s personalized nutrient profile
                                            based on {kitData?.Gender == "Female" ? "her" : "his"} DNA{" "}
                                            {kitData?.PetName} has {trueCount} Nutritional insights
                                            you could learn more about.
                                        </p>
                                        {/* <p className="card-text">OsteoArthritis</p> */}
                                    </div>
                                    <a
                                        href="javascript:void(0);"
                                        className="mt-auto align-self-start"
                                        onClick={() => handleReportData("nutritionalInsights")}
                                    >
                                        Explore Nutrition Insights →
                                    </a>
                                </div>
                            </div>
                            <div className="card report-card mb-4">
                                <div className="card-body d-flex flex-column justify-content-between">
                                    <div>
                                        <h5 className="card-title">Health Insights</h5>
                                        <p className="card-text">
                                            {kitData?.PetName} inherited {healthInsight} health
                                            insights you could learn more about.
                                        </p>
                                    </div>
                                    <a
                                        href="javascript:void(0);"
                                        className="mt-auto align-self-start"
                                        onClick={() => handleReportData("healthInsights")}
                                    >
                                        Explore Health Insights →
                                    </a>
                                </div>
                            </div>
                            <div className="card report-card mb-4">
                                <div className="card-body d-flex flex-column justify-content-between">
                                    <div>
                                        <h5 className="card-title">Recommendations</h5>
                                        <p className="card-text">
                                            Based on {kitData?.PetName}'s nutrition insights, we have
                                            identified what diet could benefit{" "}
                                            {kitData?.Gender == "Female" ? "her" : "him"} the most,
                                            based on {kitData?.Gender == "Female" ? "her" : "his"}{" "}
                                            DNA.
                                        </p>
                                    </div>
                                    <a
                                        href="javascript:void(0);"
                                        className="mt-auto align-self-start d-inline-flex-align-items-center"
                                        onClick={() => handleReportData("dietRecommendations")}
                                    >
                                        Explore Recommendations→{" "}
                                    </a>
                                </div>
                            </div>

                            <div className="card report-card mb-4">
                                <div className="card-body">
                                    <h5 className="card-title">Breed</h5>
                                    <p className="card-text">
                                        As part of this pilot research study, breed analysis is not included. Once those details are available, we wll update your profile.
                                    </p>
                                </div>
                            </div>
                        </section>
                    )}
                </div>

                {(reportData || errorMessage) && (
                    <div>
                        <div className="contentReport card-bg-color">
                            {errorMessage ? (
                                <div style={{ marginRight: "20px" }}>
                                    <br></br>
                                    <Alert variant="danger" style={{ textAlign: "center" }}>
                                        Report generation is in progress.
                                    </Alert>
                                </div>
                            ) : (
                                <>
                                    {reportData === "breedInformation" && (
                                        <BreedBreakDown ruleResult={filteredData}></BreedBreakDown>
                                    )}
                                    {reportData === "dietRecommendations" && (
                                        <Dietcondition
                                            ruleResult={filteredData}
                                            kitData={kitData}
                                            petName={kitData.PetName}
                                        ></Dietcondition>
                                    )}

                                    {reportData === "nutritionalInsights" && (
                                        <NutritionalInsights
                                            ruleResult={filteredData}
                                            kitData={kitData}
                                            petName={kitData.PetName}
                                        ></NutritionalInsights>
                                    )}

                                    {reportData === "healthInsights" && (
                                        <HealthInsights
                                            ruleResult={filteredData}
                                            kitData={kitData}
                                            petName={kitData.PetName}
                                        ></HealthInsights>
                                    )}
                                    {reportData === "lifestyleSuggestions" && (
                                        <Dog1data
                                            ruleResult={filteredData}
                                            kitData={kitData}
                                        ></Dog1data>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
export default CustomerReport;
